import { type SVGProps } from "react";

const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={18}
    fill="none"
    viewBox="0 0 18 18"
    {...props}
  >
    <path
      fill="currentColor"
      d="M8.438 14.25V9.562H3.75a.563.563 0 0 1 0-1.125h4.688V3.75a.563.563 0 0 1 1.124 0v4.688h4.688l.114.01a.563.563 0 0 1-.114 1.114H9.562v4.688a.563.563 0 0 1-1.124 0Z"
    />
  </svg>
);

export { SvgComponent as PlusIcon };

